import addMinutes from 'date-fns/addMinutes';

const getLocalDate = (date: Date = new Date()): Date => addMinutes(date, -date.getTimezoneOffset());

export default getLocalDate;
